import gql from 'graphql-tag.macro';
import { DateTime } from 'luxon';
import {
  getPositions,
  query as getPositionsQ,
} from 'queries/positions/getPositions';

export const query = getPositionsQ;
export const getPositionsQuery = getPositions;

const getRecentPostingsQuery = gql`
  query GetRecentPostings($ownedByCurrentUser: Boolean, $venueIds: [ID!]) {
    recentPostings(ownedByCurrentUser: $ownedByCurrentUser, venueIds: $venueIds) {
      id
      requestName
      position {
        id
      }
      venue {
        id
        name
        address
        city
        stateCode
        zip
        displayAddress
      }
      multiDayJobRequest {
        createdAt
        schedule
      }
      shift {
        name
        recurrenceRules {
          sunday {
            startTime
            endTime
            unpaidBreakMinutes
          }
          monday {
            startTime
            endTime
            unpaidBreakMinutes
          }
          tuesday {
            startTime
            endTime
            unpaidBreakMinutes
          }
          wednesday {
            startTime
            endTime
            unpaidBreakMinutes
          }
          thursday {
            startTime
            endTime
            unpaidBreakMinutes
          }
          friday {
            startTime
            endTime
            unpaidBreakMinutes
          }
          saturday {
            startTime
            endTime
            unpaidBreakMinutes
          }
        }
      }
      workerGroup
      payRate {
        amount
        currencyCode
      }
      payTypeObject {
        id
      }
      isPayDisplayedAsHourlyRate
      createdAt
    }
  }
`;

const recentPostingsReducer = (data) => data.recentPostings.map(({ multiDayJobRequest, payTypeObject, ...rest }) => {
  const schedule = multiDayJobRequest?.schedule || {};
  return {
    ...rest,
    payTypeId: payTypeObject.id,
    multiDayJobRequest,
    schedule: Object.keys(schedule).map((scheduleDate) => {
      const date = DateTime.fromISO(scheduleDate);
      return {
        ...multiDayJobRequest.schedule[scheduleDate],
        date,
      };
    }),
  };
});

export const getRecentPostings = {
  query: getRecentPostingsQuery,
  reducer: recentPostingsReducer,
};
